import React, { useState } from "react";
import { useMatch } from "react-router-dom";
import { ChatWindow } from "./ChatWindow";
import { BodhiBot } from "./BodhiBot";
import { CodeVaani } from "./CodeVaani";

const ChatWindowManager = ({ botEnabled }) => {
  const [bodhibotEnabled, setBodhibotEnabled] = useState(botEnabled);
  const [bodhibotLoggingEnabled, setBodhibotLoggingEnabled] = useState(false);
  const [selectedBot, setSelectedBot] = useState("BodhiBot");

  const match = useMatch("/courseware/course/:courseId/content/labs/:labId/programming/:activityID");
  const { courseId, labId, activityID } = match?.params || {};

  const options = ["BodhiBot", "CodeVaani"];

  return (
    <ChatWindow
      title={selectedBot}
      options={options}
      onTitleChange={setSelectedBot}
      isEnabled={bodhibotEnabled}
    >
      {selectedBot === "BodhiBot"
        ? ({ setIsOpen }) => (
            <BodhiBot
              bodhibotEnabled={bodhibotEnabled}
              setBodhibotEnabled={setBodhibotEnabled}
              bodhibotLoggingEnabled={bodhibotLoggingEnabled}
              setBodhibotLoggingEnabled={setBodhibotLoggingEnabled}
              onOpenChatWindow={() => setIsOpen(true)}
            />
          )
        : match ? <CodeVaani
            courseId= {courseId}
            labId= {labId}
            activityID= {activityID}
          /> : <div style={{ flexGrow: "1", justifyContent: "center", alignContent: "center"}}><h6 style={{ textAlign: "center" }}>CodeVaani is only available for Programming Activity</h6></div>
      }
    </ChatWindow>
  );
};

export default ChatWindowManager;
